/**
 * cooperation
 * 合作咨询
 */
export default {
    name: 'cooperation',
    path: '/cooperation',
    meta: {},
    component: () => import('@/views/cooperation/Home'),
    redirect: '/cooperation/index',
    children: [
        {
            name: 'cooperationIndex',
            path: 'index',
            meta: {},
            component: () => import('@/views/cooperation/Index'),
        },
    ],
};
